var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flag"},[_c('span',{staticClass:"flag-icon flag-icon-br",on:{"click":function($event){return _vm.change('pt-BR')}}}),_c('span',{staticClass:"flag-icon flag-icon-en",on:{"click":function($event){return _vm.change('en')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }